export class API_SETTINGS {
  // FOR COLLEGES
  //public static API_URL = 'https://enetcloud-saas-enetreality-colleges-api.azurewebsites.net/api/';

  // FOR LIVE
  //public static API_URL = 'https://enetcloud-saas-enetreality.azurewebsites.net/api/';

  // FOR UAT:
  //public static API_URL = 'https://enetcloud-saas-enetreality-api-uat.azurewebsites.net/api/'

  // FOR QA:
  public static API_URL = 'https://enetcloud-uk6-test-enetreality-api.azurewebsites.net/api/';

  // FOR DEV RUNNING LOCAL:
  // public static API_URL = 'https://localhost:5001/api/';
  //public static API_URL = 'https://localhost:44385/api/';
}